export const SEND_MESSAGE_TO_SUPPORT_START = 'SEND_MESSAGE_TO_SUPPORT_START';
export const SEND_MESSAGE_TO_SUPPORT_COMPLETED = 'SEND_MESSAGE_TO_SUPPORT_COMPLETED';
export const SEND_MESSAGE_TO_SUPPORT_ERROR = 'SEND_MESSAGE_TO_SUPPORT_ERROR';

export const SEND_FEEDBACK_TO_SUPPORT_START = 'SEND_FEEDBACK_TO_SUPPORT_START';
export const SEND_FEEDBACK_TO_SUPPORT_COMPLETED = 'SEND_FEEDBACK_TO_SUPPORT_COMPLETED';
export const SEND_FEEDBACK_TO_SUPPORT_ERROR = 'SEND_FEEDBACK_TO_SUPPORT_ERROR';

export const sendMessageToSupport = (message: string) => {
    return {
        type: SEND_MESSAGE_TO_SUPPORT_START,
        payload: { message }
    };
};

export const sendMessageToSupportCompleted = () => {
    return {
        type: SEND_MESSAGE_TO_SUPPORT_COMPLETED,
        payload: {}
    };
};

export const sendMessageToSupportError = (error: any) => {
    return {
        type: SEND_MESSAGE_TO_SUPPORT_ERROR,
        payload: {},
        error: error
    };
};

//--------------------------------------------------------------------------------

export const sendFeedbackToSupport = ({ message, starRatingData }: { message: string, starRatingData: any }) => {
    return {
        type: SEND_FEEDBACK_TO_SUPPORT_START,
        payload: { message, starRatingData }
    };
};

export const sendFeedbackToSupportCompleted = (starRatingData: any) => {
    return {
        type: SEND_FEEDBACK_TO_SUPPORT_COMPLETED,
        payload: { starRatingData }
    };
};

export const sendFeedbackToSupportError = (error: any) => {
    return {
        type: SEND_FEEDBACK_TO_SUPPORT_ERROR,
        payload: {},
        error: error
    };
};
